import { useState, useEffect } from 'react';
import { getNews, createNews, updateNews, deleteNews, convertToLegacyNews, convertLegacyNews } from '../lib/supabase';

export function useSupabaseNews() {
  const [news, setNews] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadNews = async () => {
    try {
      setLoading(true);
      const newsData = await getNews();
      const legacyNews = newsData.map(convertToLegacyNews);
      setNews(legacyNews);
      setError(null);
    } catch (err: any) {
      console.error('Error loading news:', err);
      setError(err.message);
      setNews([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadNews();
  }, []);

  const addNews = async (newsData: any) => {
    try {
      const supabaseNews = convertLegacyNews(newsData);
      const created = await createNews(supabaseNews);
      await loadNews();
      return created;
    } catch (err: any) {
      console.error('Error adding news:', err);
      throw err;
    }
  };

  const updateNewsItem = async (id: string, newsData: any) => {
    try {
      const supabaseNews = convertLegacyNews(newsData);
      const updated = await updateNews(id, supabaseNews);
      await loadNews();
      return updated;
    } catch (err: any) {
      console.error('Error updating news:', err);
      throw err;
    }
  };

  const deleteNewsItem = async (id: string) => {
    try {
      await deleteNews(id);
      await loadNews();
    } catch (err: any) {
      console.error('Error deleting news:', err);
      throw err;
    }
  };

  return {
    news,
    loading,
    error,
    addNews,
    updateNews: updateNewsItem,
    deleteNews: deleteNewsItem,
    refreshNews: loadNews
  };
}
